import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { storage } from '../../config/fbConfig';
import { genString } from '../../utils/StringUtil';
const refModal = React.createRef();
const refModalPyns = React.createRef();
const refModalReward = React.createRef();
const type = 'SAFETY';
const subType = 'SCHOOL_ZONE';
const safetyBadgeFunction = 'getDetailBadgeSafety';

function NewBadge(props) {
  const { firestore, companies, edit, safetyPynsObject, badge, allRewards, badgeRewards } = props;
  const [companyId, setCompanyId] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [imageDisable, setImageDisable] = useState('');
  const [imageDisableUrl, setImageDisableUrl] = useState('');
  const [name, setName] = useState('');
  const [pyns, setPyns] = useState([]);
  const [quantity, setQuantity] = useState(0);
  const [searchName, setSearchName] = useState('');
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [redirecToBadgesList, setRedirecToBadgesList] = useState(false);
  const [safetyPyns, setSafetyPyns] = useState([]);
  const [filteredPyns, setFilteredPyns] = useState([]);
  const [searchPyn, setSearchPyn] = useState('');
  const [rewards, setRewards] = useState([]);
  const [badgeReward, setBagdeReward] = useState({ rewardId: '' });
  const [badgeRewardImage, setBagdeRewardImage] = useState('');

  const setBadge = (badge) => {
    setCompanyId(badge.companyId);
    setDescription(badge.description);
    setImageUrl(badge.image);
    setImageDisableUrl(badge.imageDisable);
    setName(badge.name);
    setPyns(badge.pyns);
    setQuantity(badge.quantity);
    setCountryCode(badge.countryCode);
  };

  useEffect(() => {
    if (!badge || !badgeRewards) return;
    const currentReward = badgeRewards[badge.id];
    if (currentReward) setBagdeReward(currentReward);
  }, [badgeRewards, badge]);

  const filterCompanies = useCallback((country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return company.countryCode === country && (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true);
    });
    setCurrentCompanies(filteredCompanies);
  }, [companies]);
  
  useEffect(() => M.AutoInit(), [countryCode]);

  useEffect(() => {
    if (badge) {
      setBadge(badge);
      filterCompanies(badge.countryCode, '');
    }
  }, [badge, filterCompanies]);

  useEffect(() => {
    if (!safetyPynsObject) return;
    let pyns = [];
    for (var key in safetyPynsObject) {
      var value = { ...safetyPynsObject[key] };
      value.id = key;
      pyns.push(value);
    }
    setSafetyPyns(pyns);
  }, [safetyPynsObject]);

  useEffect(() => {
    if (!allRewards) return;
    let rewards = [];
    for (var key in allRewards) {
      var value = { ...allRewards[key] };
      value.id = key;
      rewards.push(value);
    }
    setRewards(rewards);
  }, [allRewards]);

  const createBadge = () => {
    if (!validateBadge()) {
      alert('Please fill in all the minimum fields');
      return;
    }
    const newBadge = {
      updatedAt: firestore.FieldValue.serverTimestamp(),
      function: safetyBadgeFunction,
      companyId,
      countryCode,
      description,
      name,
      pyns,
      quantity: Number(quantity),
      type,
      subType,
    };
    saveBadge(newBadge);
  };

  const validateBadge = () => countryCode.trim() !== '' && companyId.trim() !== '' && name.trim() !== '' && description.trim() !== '' && quantity.toString().trim() !== '';

  const saveBadge = (newBadge) => {
    const [query, docId] = generateQuery(newBadge);
    query
      .then(() => {
        setRedirecToBadgesList(true);
        uploadBadgeImage(image, docId, 'image', 'badges');
        uploadBadgeImage(imageDisable, docId, 'imageDisable', 'badges');
        saveBadgeReward(docId);
      })
      .catch((error) => console.error(error));
  };

  const generateQuery = (newBadge) => {
    let query = firestore.collection('badges');
    let docId = '';
    if (edit) {
      query = query.doc(badge.id).set(newBadge, { merge: true });
      docId = badge.id;
    } else {
      const newRef = query.doc();
      docId = newRef.id;
      query = newRef.set({ id: newRef.id, ...newBadge });
    }
    return [query, docId];
  };

  const saveBadgeReward = (badgeId) => {
    if (badgeReward.rewardId.trim() === '') return;
    firestore
      .collection('badgeRewards')
      .doc(badgeId)
      .set({ ...badgeReward, idCompany: companyId }, { merge: true })
      .then(() => uploadBadgeImage(badgeRewardImage, badgeId, 'image', 'badgeRewards'))
      .catch((error) => console.error(error));
  };

  const validateBadgeReward = () => badgeReward.rewardId.trim() !== '' && badgeReward.name.trim() !== '' && badgeReward.description.trim() !== '' && badgeReward.terms.trim() !== '';

  const uploadBadgeImage = (img, docId, field, collection) => {
    if (img) {
      uploadImage('badges-image', img, (imageUrl) => {
        firestore
          .collection(collection)
          .doc(docId)
          .update({ [field]: imageUrl });
      });
    }
  };

  const uploadImage = (folder, file, newImageurl) => {
    const newFileName = genString(5) + file.name;
    const uploadTask = storage.ref(`/${folder}/${newFileName}`).put(file);
    uploadTask.on(
      'state_changed',
      (snapShot) => console.log(snapShot),
      (err) => console.error(err),
      () => {
        storage
          .ref(folder)
          .child(newFileName)
          .getDownloadURL()
          .then((fireBaseUrl) => newImageurl(fireBaseUrl));
      },
    );
  };

  const openCompanyDialog = () => M.Modal.getInstance(refModal.current).open();

  const openPynsModal = () => {
    filterPyns();
    M.Modal.getInstance(refModalPyns.current).open();
  };

  const updateCountry = (country) => {
    setCountryCode(country);
    filterCompanies(country, '');
  };

  const filterPyns = () => {
    if (!countryCode || !companyId) return;
    const filtered = safetyPyns.filter((pyn) => pyn.d.country === countryCode && pyn.d.uidCompany === companyId);
    setFilteredPyns(filtered);
  };

  const search = (searchTerm) => {
    setSearchName(searchTerm);
    filterCompanies(countryCode, searchTerm);
  };

  const searchPyns = () => {
    const text = searchPyn.toLowerCase();
    if (text === '') {
      filterPyns();
      return;
    }
    const filtered = safetyPyns.filter((pyn) => (pyn.d.name && pyn.d.name.toLowerCase().includes(text)) || (pyn.d.state && pyn.d.state.toLowerCase().includes(text)) || (pyn.d.city && pyn.d.city.toLowerCase().includes(text)));
    setFilteredPyns(filtered);
  };

  const renderCompanyDialog = () => {
    return (
      <div ref={refModal} className="modal">
        <div className="modal-content">
          <h5>Company ID</h5>
          <div className="row">
            <div className="input-field col s12">
              <input id="searchName" type="text" className="validate" value={searchName} onChange={(e) => search(e.target.value)} />
              <label htmlFor="searchName">Company name</label>
            </div>
          </div>
          <div className="search-container">{currentCompanies.map((company) => renderCompany(company))}</div>
        </div>
        <div className="modal-footer">
          <div className="modal-close waves-effect btn btn-flat" onClick={() => search('')}>
            Cancel
          </div>
        </div>
      </div>
    );
  };

  const renderCompany = (company) => (
    <div key={company.id}>
      <div
        onClick={() => {
          setCompanyId(company.uid);
          search('');
        }}
        className="modal-close waves-effect btn btn-flat">
        {company.companyName}
      </div>
    </div>
  );

  const renderPynsModal = () => {
    return (
      <div ref={refModalPyns} className="modal">
        <div className="modal-content">
          <h5>Select pyns</h5>
          {renderPynSearchInput()}
          <div className="search-container">{filteredPyns.map((pyn) => renderPyn(pyn))}</div>
        </div>
        <div className="modal-footer">
          <div className="modal-close waves-effect btn btn-flat">OK</div>
        </div>
      </div>
    );
  };

  const renderPynSearchInput = () => (
    <div className="row">
      <div className="input-field col s6">
        <input id="searchPyn" type="text" className="validate" value={searchPyn} onChange={(e) => setSearchPyn(e.target.value)} />
        <label htmlFor="searchPyn">Search by name, city or state</label>
      </div>
      <div className="input-field col s6">
        <div className="btn btn-medium" onClick={() => searchPyns()} style={{ marginRight: 5 }}>
          Search
        </div>
        <div className="btn btn-medium" onClick={() => setPyns(filteredPyns.map((pyn) => pyn.d.id))} style={{ marginRight: 5 }}>
          Select all
        </div>
        <div className="btn btn-medium" onClick={() => setPyns([])}>
          Deselect all
        </div>
      </div>
    </div>
  );

  const renderPyn = (pyn) => (
    <div key={pyn.d.id} onClick={() => addOrRemovePyn(pyn)} style={{ margin: 5 }}>
      <div className="collection-item" style={{ backgroundColor: `${pyns.includes(pyn.d.id) ? '#EBEBEB' : 'transparent'}` }}>
        <div style={{ color: '#26A59A' }}>{pyn.d.name}</div>
        <div>{`${pyn.d.city}${pyn.d.city && pyn.d.state ? ', ' : ''}${pyn.d.state}`}</div>
        {pyn.d.address && <div>{pyn.d.address}</div>}
      </div>
    </div>
  );

  const addOrRemovePyn = (pyn) => {
    if (!pyns.includes(pyn.d.id)) {
      setPyns((oldArray) => [...oldArray, pyn.d.id]);
    } else {
      setPyns((oldArray) => oldArray.filter((e) => e !== pyn.d.id));
    }
  };

  const renderImages = () => (
    <div className="row">
      {renderImage(imageUrl, 'Badge image')}
      {renderImage(imageDisableUrl, 'Disabled badge image')}
    </div>
  );

  const renderImage = (source, label) => (
    <div className="col s4">
      <img src={source} alt="" className="company-logo" />
      <br />
      <small>{label}</small>
    </div>
  );

  const renderCountrySelect = () => (
    <div className="input-field col s12">
      <select className="icons" value={countryCode} onChange={(e) => updateCountry(e.target.value)}>
        <option value="" disabled>
          Select your Country
        </option>
        <option data-icon="images/ca.svg" value="CA">
          Canada
        </option>
        <option data-icon="images/us.svg" value="US">
          United States
        </option>
        <option data-icon="images/bo.svg" value="BO">
          Bolivia
        </option>
      </select>
      <label>Country</label>
    </div>
  );

  const openRewardModal = () => M.Modal.getInstance(refModalReward.current).open();

  const closeRewardModal = () => {
    const modal = document.getElementById('rewardModal');
    M.Modal.getInstance(modal).close();
  };

  const renderRewardModal = () => {
    return (
      <div ref={refModalReward} className="modal" id="rewardModal">
        <div className="modal-content">
          <h5>Badge Reward</h5>
          <div className="col s4">
            <img src={badgeReward.image} alt="" className="company-logo" />
            <br />
          </div>
          {renderBadgeReward()}
          <div className="row">
            <div className="input-field col s12">
              <input id="name" type="text" className="validate" value={badgeReward.name || ''} onChange={(e) => setBagdeReward({ ...badgeReward, name: e.target.value })} />
              <label htmlFor="name" className="active">
                Name
              </label>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <textarea id="desc" className="materialize-textarea" value={badgeReward.description || ''} onChange={(e) => setBagdeReward({ ...badgeReward, description: e.target.value })} />
              <label htmlFor="desc" className="active">
                Description
              </label>
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <textarea id="terms" className="materialize-textarea" value={badgeReward.terms || ''} onChange={(e) => setBagdeReward({ ...badgeReward, terms: e.target.value })} style={{ marginTop: 10 }}></textarea>
              <label htmlFor="terms" className="active">
                Terms
              </label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col s12" style={{ marginLeft: 20 }}>
            <div className="file-field input-field ">
              <div className="btn">
                <span>Image</span>
                <input type="file" onChange={(e) => setBagdeRewardImage(e.target.files[0])} />
              </div>
              <div className="file-path-wrapper">
                <input className="file-path validate" type="text" />
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="modal-close waves-effect btn btn-flat" onClick={() => setBagdeReward({ rewardId: '' })}>
            Clear
          </div>
          <div
            className="waves-effect btn btn-flat"
            onClick={() => {
              if (!validateBadgeReward()) {
                alert('Please fill in all the minimum fields');
              } else {
                closeRewardModal();
              }
            }}>
            OK
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    var elems = document.querySelectorAll('select');
    M.FormSelect.init(elems, {});
  }, [companyId, rewards, badgeReward]);

  const renderBadgeReward = () => {
    const filteredRewards = rewards.filter((reward) => (reward.uidCompany && reward.uidCompany === companyId) || (reward.idCompany && reward.idCompany === companyId));
    return (
      <div className="input-field col s12">
        <select value={badgeReward.rewardId} onChange={(e) => setBagdeReward({ ...badgeReward, rewardId: e.target.value })}>
          <option value="" disabled>
            Choose a reward
          </option>
          {filteredRewards.map((reward) => (
            <option key={reward.id} value={reward.id}>
              {reward.description}
            </option>
          ))}
        </select>
        <label>Reward</label>
      </div>
    );
  };

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (redirecToBadgesList) return <Redirect to="/badges" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            <div className="row">
              <h3>{`${edit ? 'Edit' : 'New'} Safety Badge`}</h3>
            </div>
            {renderImages()}
            <div className="row">{renderCountrySelect()}</div>
            <div className="row">
              <div className="input-field col s12">
                <input id="name" type="text" className="validate" value={name} onChange={(e) => setName(e.target.value)} />
                <label htmlFor="name" className="active">
                  Name
                </label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <textarea id="description" className="materialize-textarea" value={description} onChange={(e) => setDescription(e.target.value)} style={{ marginTop: 10 }} />
                <label htmlFor="description" className="active">
                  Description
                </label>
              </div>
            </div>
            <div className="row">
              <div className="input-field col s12">
                <input id="quantity" type="number" className="validate" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                <label htmlFor="quantity" className="active">
                  Quantity
                </label>
              </div>
            </div>
            <div className="col s12">
              <div className="file-field input-field ">
                <div className="btn">
                  <span>Image</span>
                  <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                </div>
                <div className="file-path-wrapper">
                  <input className="file-path validate" type="text" />
                </div>
              </div>
            </div>
            <div className="col s12">
              <div className="file-field input-field ">
                <div className="btn">
                  <span>Image disabled</span>
                  <input type="file" onChange={(e) => setImageDisable(e.target.files[0])} />
                </div>
                <div className="file-path-wrapper">
                  <input className="file-path validate" type="text" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="input-field">
                <div className="col s6">
                  <label htmlFor="company_uid">Company ID</label>
                  <input id="company_uid" type="text" name="uidCompany" value={companyId} onChange={(e) => setCompanyId(e.target.value)} />
                </div>
                <div className="col s6">
                  <div className="btn btn-medium" onClick={() => openCompanyDialog()}>
                    Select company
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col s6">
                <div className="btn btn-medium" onClick={(e) => openPynsModal()}>
                  Select Pyns
                </div>
              </div>
              <div className="col s6">
                <div className="btn btn-medium" onClick={(e) => openRewardModal()}>
                  Add badge reward
                </div>
              </div>
            </div>
          </div>
          {renderCompanyDialog()}
          {renderPynsModal()}
          {renderRewardModal()}
          <div className="card-action">
            <div className="waves-effect waves-light btn btn-large" onClick={createBadge}>
              {edit ? 'Update' : 'Create'}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    companies: state.firestore.ordered.companies,
    auth: state.firebase.auth,
    badge: ownProps.location.badge,
    edit: ownProps.location.edit,
    safetyPynsObject: state.firestore.data['safetyPyns'],
    allRewards: state.firestore.data.rewards,
    badgeRewards: state.firestore.data.badgeRewards,
  };
};
export default compose(
  firestoreConnect([
    { collection: 'companies', orderBy: ['companyName', 'asc'] },
    {
      collection: 'pyns',
      where: ['d.type', '==', type],
      storeAs: 'safetyPyns',
    },
    { collection: 'rewards' },
    { collection: 'badgeRewards' },
  ]),
  connect(mapStateToProps),
)(NewBadge);
